import { GetEpisodeResponse } from '@/services/ProjectsService'
import { GetEpisodeAndUserWatchDataQuery } from '@/types/codegen-federation'

/**
 * Creates a partial GetEpisodeResponse with the fields actually used by WatchEpisodeHero and CollectiblesPlayer
 * This is a temporary compatibility layer while we transition to the new Content API
 */
export function createCompatibleEpisodeResponse(
  data: GetEpisodeAndUserWatchDataQuery | undefined,
): Partial<GetEpisodeResponse> | undefined {
  if (!data) return undefined

  return {
    project: data.project
      ? {
          // Only include fields that are actually used by the components
          name: data.project.name ?? '',
          logoCloudinaryPath: data.project.logoCloudinaryPath,
          pifEnabled: data.project.pifEnabled ?? false,
          projectType: data.project.projectType,
          title: data.project.title,
          // Add minimal required fields to satisfy the type
          id: data.project.id,
          slug: data.project.slug ?? '',
          publisherName: '', // Not used by these components
          projectName: data.project.name ?? '', // Not used by these components
          seasons: [], // Use the Content API structure instead
          discoveryPosterLandscapeCloudinaryPath: data.project.discoveryPosterLandscapeCloudinaryPath,
          discoveryVideoLandscapeUrl: data.project.discoveryVideoLandscapeUrl,
        }
      : undefined,
    episode: data.episode
      ? {
          // Fields used by the components
          seasonNumber: data.episode.seasonNumber,
          episodeNumber: data.episode.episodeNumber,
          subtitle: data.episode.subtitle,
          earlyAccessDate: data.episode.earlyAccessDate,
          publiclyAvailableDate: data.episode.publiclyAvailableDate,
          // Add minimal required fields to satisfy the type
          description: data.episode.description ?? '',
          guid: data.episode.guid ?? '',
          id: data.episode.id ?? '',
          name: data.episode.name ?? '',
          posterCloudinaryPath: data.episode.posterCloudinaryPath ?? '',
          projectSlug: data.episode.projectSlug ?? '',
          releaseDate: data.episode.releaseDate ?? '',
          seasonId: data.episode.seasonId ?? '',
          slug: data.episode.slug ?? '',
          source: {
            credits: data.episode.source?.credits ?? 0,
            duration: data.episode.source?.duration ?? 0,
            url: data.episode.source?.url ?? '',
          },
        }
      : undefined,
  } as Partial<GetEpisodeResponse>
}
